 <div *ngIf="dataAvailability" class="notification-color-orange">
    <div class="notification-color-white">
    </div>
 </div>
